import { useEffect } from "react";
import styles from "./RendirectToDiscord.module.css";

function Login() {
  useEffect(() => {
    window.location.href = "https://discord.com/oauth2/authorize?client_id=1368164502360555590&response_type=code&redirect_uri=https%3A%2F%2Feclipsebots.com%2Flogin%2Fdiscord%2Fcallback&scope=identify+guilds.join+email";
  }, []);

  return (
    <div className={styles.content}>
      <div className={styles.size}>Redirecionando para o link...</div>
    </div>
  );
}

export default Login;
